<template>
    <div style="display: inline-flex;width: 100%;height: 100%">
        <el-autocomplete v-if="isInput"
                         :ref="refId"
                         :key="key"
                         :placeholder="getPlaceholder"
                         :size="getComponentSize"
                         v-model="text"
                         :fetch-suggestions="queryConditionFilter"
                         @select="selectHandler"
                         :trigger-on-focus=true
                         placement="bottom"
                         clearable
                         :style="componentStyle"
                         :class="componentClass"
                         @clear="getFocus"
                         @keyup.native="inputHandler"
                         v-bind="$attrs"
                         :debounce="300">
            <template slot-scope="{item}">
                <div v-if="!highLightMatched || isAll" class="textOverflow">{{$comUtils.isEmpty(labelKey) ? item : item[labelKey]}}</div>
                <div v-else class="textOverflow">
                    <span>{{item.matchedValues[0]}}</span>
                    <span class="highLightText">{{item.matchedValues[1]}}</span>
                    <span>{{item.matchedValues[2]}}</span>
                </div>
            </template>
        </el-autocomplete>

        <el-select v-if="isSelect"
                   :key="key"
                   v-model="realValue"
                   :ref="refId"
                   :style="componentStyle"
                   :class="componentClass"
                   :filterable="true"
                   style="width: 220px"
                   :size="getComponentSize"
                   @visible-change="resetShowOptions"
                   :value-key="!$comUtils.isEmpty(applyValueKey) && (!isAll || isObject) ? applyValueKey : undefined"
                   :filter-method="queryConditionFilter">
            <el-option v-for="(item, index) in showOptions"
                       :label="$comUtils.isEmpty(labelKey) ? item : item[labelKey]"
                       :value="$comUtils.isEmpty(applyValueKey) || isAll ? item : item[applyValueKey]"
                       :key="index + Math.floor(Math.random() * 1000000000)">
                <div v-if="!highLightMatched || isAll" class="textOverflow">{{$comUtils.isEmpty(labelKey) ? item : item[labelKey]}}</div>
                <div v-else class="textOverflow">
                    <span>{{item.matchedValues[0]}}</span>
                    <span class="highLightText">{{item.matchedValues[1]}}</span>
                    <span>{{item.matchedValues[2]}}</span>
                </div>
            </el-option>
        </el-select>
    </div>
</template>

<script>
    let timer;
    export default {
        name: "MyAutoComplete",
        props: {
            // 用于获取历史搜索
            uniqueNum: {
                type: String
            },
            // 组件数据库配置 input/select
            componentDetail: {
                type: Object,
                required: true
            },
            // 所有可选项 对象或数组 input/select
            allOptions: {
                type: Array,
                required: true
            },
            // 提示项展示的字段 参数为当前输入的文本（仅在allOptions是对象数组的情况下需要且必须）input/select
            showValueField: {
                type: [Function, String],
                default: 'value'
            },
            // 真正的值的字段 参数为当前输入的文本和当前提示项展示的字段（仅在allOptions是对象数组的情况下需要）input/select
            // 特殊值: useCurrentObject: 返回整个对象
            applyValueField: {
                type: [Function, String],
            },
            // 匹配时需要匹配的字段列表（即输入的文本要和allOptions中元素的那些字段进行匹配） input/select
            matchFields: {
                type: Array,
                required: false
            },
            // 是否高亮匹配部分(数据多时可能会影响性能) input/select
            highLightMatched: {
                type: Boolean,
                default: false
            },
            // 绑定数据 ※必须使用 v-bind.数据.sync 或 :数据.sync 形式绑定 input/select
            // sync语法糖 :a.sync="" 等价于 :a="" @update:a="a = $event"
            value: {
                // type: String,
                required: true
            },
            // 输入框显示的值是否实际值 input 尽量不要使用，好像有BUG
            isShowValue: {
                type: Boolean,
                default: false
            },
            // 组件类型 input/select 可选值：select 和 input
            componentType: {
                type: String,
                default: 'input'
            },
            // 对外发布的elementUI原生事件
            emitOriginEvent: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            // 组件样式
            componentStyle: {
                type: Object
            },
            // 组件的类名
            componentClass: {
                type: String,
                default: ''
            },
            // 展示的值 ※必须使用 v-bind.数据.sync 或 :数据.sync 形式绑定 input/select
            showValue: {
                type: String,
            }
        },
        data: function() {
            return {
                refId: 'myAutoComplete_' + new Date().getMilliseconds(),
                key: '999999999999999',
                text: this.value,
                isAll: true,
                realValue: '',
                // select 组件用
                showOptions: [],
                inputCache: '',
                // 三个状态 -1：标志不需要将realValue的更新回传给value
                //          0： 标志需要将value的值更新到realValue和text
                //          1： 标志不需要将value的更新回传给realValue
                textChangeFlag: 0,
            }
        },
        methods: {
            /** 获取提示列表的方法 input + select */
            queryConditionFilter: function (input, callback) {
                let context = this;
                // 需要加上这个延时才会出现加载状态
                clearTimeout(timer)
                timer = setTimeout(() => {
                    // 保证点击clear时值是对的
                    if (context.isInput) {
                        input = context.text;
                    }
                    input = input + '';
                    context.inputCache = input;
                    let options = context.allOptionsStr;
                    if (context.isObject) {
                        this.commonQueryConditionFilter(input, callback, options, ...context.matchFields);
                    } else {
                        this.commonQueryConditionFilter(input, callback, options);
                    }
                }, 100)
            },
            /** 通用提示过滤器 input + select */
            commonQueryConditionFilter: function (input, callback, options, ...fields) {
                let isAll = false;
                let result = [];
                // 选择框时，无回调函数，自定义一个
                if (this.isSelect) {
                    callback = (array) => {
                        this.showOptions = array;
                    }
                }
                if (this.$comUtils.isEmpty(input) || options.length === 0) {
                    result = options;
                    isAll = true;
                } else {
                    if (this.isObject) {
                        for (let i = 0; i < options.length; i++) {
                            let value = options[i];
                            for (let i = 0; i < fields.length; i++) {
                                let text = value[fields[i]];
                                if (!this.$comUtils.isEmpty(text) && text.indexOf(input) >= 0) {
                                    if (this.highLightMatched) {
                                        let highText = value[this.labelKey];
                                        let indexOf = highText.indexOf(input);
                                        let matchedArray = [
                                            highText.substr(0, indexOf),
                                            highText.substr(indexOf, input.length),
                                            highText.substr(indexOf + input.length)
                                        ];
                                        value.matchedValues = matchedArray;
                                    }
                                    result.push(value)
                                }
                            }
                        }
                    } else {
                        for (let i = 0; i < options.length; i++) {
                            let value = options[i] + '';
                            let indexOf;
                            if (!this.$comUtils.isEmpty(value) && (indexOf = value.indexOf(input)) >= 0) {
                                if (this.highLightMatched) {
                                    let matchedArray = [
                                        value.substr(0, indexOf),
                                        value.substr(indexOf, input.length),
                                        value.substr(indexOf + input.length)
                                    ];
                                    let obj = {}
                                    obj.matchedValues = matchedArray;
                                    obj.text = value;
                                    value = obj;
                                }
                                result.push(value)
                            }
                        }
                    }
                }
                callback(result);
                this.isAll = isAll;
            },
            /** 提示项点击事件 input */
            selectHandler: function (select) {
                this.textChangeFlag = 0;
                this.$nextTick(() => {
                    if (!this.$comUtils.isEmpty(this.applyValueKey) && !this.isAll) {
                        this.realValue = select[this.applyValueKey];
                    } else {
                        this.realValue = select;
                    }

                    if (!this.$comUtils.isEmpty(this.labelKey)) {
                        this.text = select[this.labelKey];
                    } else {
                        this.text = this.highLightMatched && !this.isAll ? select.text : select;
                    }
                    this.$emit('mySelect', this.text, select, this.labelKey);
                })
            },
            /** 重新获取焦点 input */
            getFocus: function () {
                let $ref = this.$refs[this.refId];
                $ref.$el.getElementsByTagName('input')[0].blur();
                $ref.focus();
                this.realValue = '';
            },
            /** 选择框隐藏时：重置可选项 清空输入的状态 */
            resetShowOptions: function (show) {
                if (!show) {
                    setTimeout(() => {
                        this.showOptions = this.allOptionsStr;
                        this.isAll = true;
                        this.inputCache = '';
                    }, 100)
                }
            },
            inputHandler: function (data) {
                // console.log('输入=>'+ this.text)
                this.textChangeFlag = 1;
                this.realValue = this.text;
            },
            setValue: function (nV) {
                this.textChangeFlag = -1;
                if (!this.isShowValue) {
                    if (!this.$comUtils.isEmpty(nV)) {
                        let matched = this.allOptionsStr.filter(item => {
                            if (!this.$comUtils.isEmpty(this.applyValueKey)) {
                                return item[this.applyValueKey] === nV;
                            } else {
                                return this.realValue === nV;
                            }
                        })
                        if (matched.length > 0) {
                            this.text = matched[0][this.labelKey];
                        }else {
                            this.text = nV;
                        }
                    }else {
                        this.text = '';
                    }
                } else {
                    this.text = nV;
                }
                this.realValue = nV;
            }
        },
        watch: {
            allOptions: {
                handler: function (nV, oV) {
                    this.showOptions = nV;
                    // this.key = Math.floor(Math.random() * 100000000000);
                },
                deep: true
            },
            text: function (nV, oV) {
                // if (this.isShowValue) {
                //     this.realValue = nV;
                // }
                // this.inputHandler(nV, !this.isSelectItem);
                this.$emit('update:showValue', nV);
            },
            realValue: {
                handler: function (nV, oV){
                    if (this.textChangeFlag !== -1) {
                        this.textChangeFlag = 1;
                        this.$emit('update:value', nV);
                    } else {
                        this.textChangeFlag = 0;
                    }
                },
                deep: true
            },
            value: function (nV, oV) {
                // console.log('flag =>' + this.flag)
                if (this.textChangeFlag === 0) {
                    // console.log('更新text和realValue')
                    this.setValue(nV)
                } else {
                    this.textChangeFlag = 0;
                }
            },
        },
        computed: {
            /** 获取指定参数值 */
            getTittle: function () {
                let detail = this.componentDetail;
                if (this.$comUtils.isEmpty(detail)) {
                    return '';
                }
                return detail.componentTiltle[this.$i18n.locale]
            },
            /** 获取占位符信息 */
            getPlaceholder: function () {
                let detail = this.componentDetail;
                if (this.$comUtils.isEmpty(detail)) {
                    return '';
                }
                return detail.placeholderText[this.$i18n.locale]
            },
            /** 获取组件大小 */
            getComponentSize: function () {
                let detail = this.componentDetail;
                if (this.$comUtils.isEmpty(detail)) {
                    return '';
                }
                return detail.componentSize;
            },
            /** 获取是否显示 */
            isShow: function () {
                let detail = this.componentDetail;
                if (this.$comUtils.isEmpty(detail)) {
                    return false;
                }
                return detail.isShow === '1';
            },
            /** 应用的属性（实际值） */
            applyValueKey: function () {
                if (this.isObject) {
                    if (this.applyValueField !== undefined && this.applyValueField !== null) {
                        if (typeof this.applyValueField === 'string') {
                            if (['useCurrentObject'].indexOf(this.applyValueField) >= 0) {
                                return '';
                            }
                            return this.applyValueField
                        }else {
                            return this.applyValueField(this.inputCache, this.labelKey)
                        }
                    }else {
                        return this.labelKey
                    }
                }else {
                    if (this.highLightMatched) {
                        return 'text';
                    } else {
                        return '';
                    }
                }
            },
            /** 显示的属性 */
            labelKey: function () {
                if (this.isObject) {
                    if (typeof this.showValueField === 'string') {
                        return this.showValueField
                    } else {
                        return this.showValueField(this.inputCache);
                    }
                }else {
                    return '';
                }
            },
            /** 是否是 select 组件 */
            isSelect: function () {
                return this.componentType === 'select';
            },
            /** 是否是 input 组件 */
            isInput: function () {
                return this.componentType === 'input';
            },
            // allOptions中的元素是否是对象
            isObject: function () {
                return !this.$comUtils.isEmpty(this.allOptions) && ['string','number','boolean'].indexOf(typeof this.allOptions[0]) < 0;
            },
            allOptionsStr: function () {
                if (this.isObject) {
                    return this.allOptions;
                } else {
                    let res = [];
                    for (let i = 0; i < this.allOptions.length; i++) {
                        res.push('' + this.allOptions[i]);
                    }
                    return res;
                }
            }
        },
        mounted() {
            if (this.isSelect) {
                this.showOptions = this.allOptions;
            }

            for (let i = 0; i < this.emitOriginEvent.length; i++) {
                this.$refs[this.refId].$on(this.emitOriginEvent[i], (data) => {
                    this.$emit(this.emitOriginEvent[i], data);
                })
            }
        }
    }
</script>

<style scoped>
    .textOverflow {
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .highLightText {
        color: red;
    }
</style>
